module.exports = __webpack_public_path__ + "img/photographic.078577e0.jpg";